import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import styled from 'styled-components';
import {
    FEEDBACKS_CUSTOMER_STATUS,
    FEEDBACKS_ESTIMATE
} from '../../../constants';
import {
    presentationVM,
    promoFeedback,
    qrState,
    updateFeedbackState
} from '../../../state/recoilState';
import {
    BasicScreenProps,
    PromoFeedback,
    updateFeedback
} from '../../../types';
import {
    updateFeedbacks
} from '../../../utils/general';
import { isPromoEnabledForCompanyId } from '../../../utils/promo';
import ScreenTitle from '../../common/ScreenTitle';
import {
    SmileBadColor,
    SmileGoodColor,
} from './components/CheckboxItems/CheckboxSvg';
import {
    CheckboxBox,
    CustomCheckbox,
    FeedbacksButtonBox
} from './components/FeedbacksStyles';
import { SmileTitle } from './components/SmileTitle';

interface SmilePage extends BasicScreenProps {
    //onCancel?: () => void;
}

const ButtonsBox = styled(FeedbacksButtonBox)`
    justify-content: center;
`;



const SmilePage = (props: SmilePage) => {
    const [updatedFeedback, setUpdateFeedback] =
        useRecoilState<updateFeedback>(updateFeedbackState);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [vm, setVm] = useRecoilState(presentationVM);
    const [promoFeedbacks, setPromoFeedbacks] = useRecoilState<PromoFeedback>(promoFeedback);
    const [qrCode, setQrCode] = useRecoilState<string>(qrState);
    useEffect(() => {
        if(vm.id){
            if(isPromoEnabledForCompanyId(vm.companyId))
                {
                    console.log("Promo is enabled for the company with id = ", vm.companyId)
                    createFeedback(vm.id)
                }else{
                    console.warn("Promo is disabled for the company with id = ", vm.companyId)
                    navigate(`*`)
                }
        }
    }, []);
    console.log('PromoFeedbacks recoil', promoFeedbacks)

    async function createFeedback(vm: number | string): Promise<void> {
        try {
            const response = await fetch(`/api/get_feedback_data?vm=${vm}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                //body: JSON.stringify(orderInfo),
            });
            if (response.status === 200) {
                const result: PromoFeedback = await response.json();
                setPromoFeedbacks(result);
            } else {
                console.warn('Something goes wrong');
                throw new Error(response.statusText);
            }
        } catch (error) {
            console.error('Request failed:', error);
        }
    }

    const handleSmileBadChange = (props: any) => {
         const { id } = props.target;

        const isGoodFeedback = id === 'Good';
        const nextPage = isGoodFeedback ? 'wishespage' : 'checkboxpage';
        const estimate = isGoodFeedback
            ? FEEDBACKS_ESTIMATE.POSITIVE_SMILE
            : FEEDBACKS_ESTIMATE.NEGATIVE_SMILE;

        const newfeedback = {
            ...updatedFeedback,
            chosen_options: null,
            custom_content: null,
            customer_name: null,
            customer_phone_number: null,
            estimate,
            customer_status: FEEDBACKS_CUSTOMER_STATUS.AFTER_SMILE_PAGE,
            id: promoFeedbacks.id,
        };

        setUpdateFeedback(newfeedback);
        updateFeedbacks(promoFeedbacks.id, newfeedback);

        navigate(`/checkboxpage`);
    };


    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                height: '50vh',
            }}
        >
            <ScreenTitle>
                {t('Do you see the need for telemetry in your business?')}
            </ScreenTitle>
            <Box sx={{ marginTop: '4rem' }}>
                <CheckboxBox>
                    <div>
                        <CustomCheckbox
                            id="Good"
                            icon={<SmileGoodColor />}
                            onClick={handleSmileBadChange}
                        />
                        <SmileTitle text={t('Yes')} />
                    </div>
                    <div>
                        <CustomCheckbox
                            id="Bad"
                            icon={<SmileBadColor />}
                            onClick={handleSmileBadChange}
                        />

                        <SmileTitle text={t('No')} />
                    </div>
                </CheckboxBox>

                {/* <ButtonsBox>
                    <FeedbacksButton
                        onClick={onCancelClick}
                        style={DISABLE_OR_ENABLE_BUTTON[1]}
                    >
                        {t('Cancel')}
                    </FeedbacksButton>
                </ButtonsBox> */}
            </Box>
        </Box>
    );
};

export default SmilePage;
